function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M15.338 34.783c-.488.489-1.359.41-1.945-.176-.585-.586-.665-1.457-.176-1.945l19.445-19.445c.488-.489 1.359-.41 1.945.176.585.586.665 1.457.176 1.945L15.338 34.783zm-2.121-19.445c-.489-.488-.41-1.359.176-1.945.586-.585 1.457-.665 1.945-.176l19.445 19.445c.489.488.41 1.359-.176 1.945-.586.585-1.457.665-1.945.176L13.217 15.338z"
});

var SvgMenuClose = function SvgMenuClose(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgMenuClose;


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu-close.svg
// module id = 239
// module chunks = 0 1